import { DotField } from "../util/dotfield/DotField";
import "./ContentContainers.css";

export function HeaderContainer({ children, scrolled }) {
	return (
		<header className={`headerContainer ${scrolled ? "-scrolled" : ""}`}>
			<div className="headerContainer_inner">{children}</div>
		</header>
	);
}

export function HeroContainer({ children, id }) {
	return (
		<section className="heroContainer" id={id}>
			<div className="heroContainer_bg" aria-hidden="true">
				<div className="heroContainer_vignette" />
			</div>
			<div className="heroContainer_content">{children}</div>
		</section>
	);
}

export function SectionContainer({ children, id, variant = "light", className, field }) {
	return (
		<section
			className={`sectionContainer sectionContainer--${variant} ${className || ""}`.trim()}
			id={id}
		>
			{field && (
				<div className="sectionContainer_field" aria-hidden="true">
					<DotField spacing={32} />
				</div>
			)}
			<div className="sectionContainer_content">{children}</div>
		</section>
	);
}

export function CardContainer({ children, mod, variant = "default", as: Tag = "div", ...rest }) {
	return (
		<Tag className={`cardContainer cardContainer--${variant} ${mod || ""}`} {...rest}>
			{children}
		</Tag>
	);
}

export function FooterContainer({ children }) {
	return (
		<footer className="footerContainer">
			<div className="footerContainer_inner">{children}</div>
		</footer>
	);
}
